import api from './api';

export interface Tutor {
  id: string;
  nome: string;
  email: string;
  telefone?: string;
  cpf?: string;
  endereco?: string;
}

export interface RegisterData {
  email: string;
  senha: string;
  nome: string;
  telefone?: string;
}

export interface LoginData {
  username: string;
  password: string;
}

export const tutorAuthService = {
  async login(email: string, password: string) {
    const formData = new FormData();
    formData.append('username', email);
    formData.append('password', password);
    
    const response = await api.post('/tutor/login', formData, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });
    
    if (response.data.access_token) {
      localStorage.setItem('tutor_token', response.data.access_token);
    }
    
    return response.data;
  },

  async register(data: RegisterData) {
    const response = await api.post('/tutor/register', data);
    return response.data;
  },

  async getCurrentTutor(): Promise<Tutor> {
    const response = await api.get('/tutor/me');
    return response.data;
  },

  async updateTutor(data: { telefone?: string }): Promise<Tutor> {
    const response = await api.patch('/tutor/me', data);
    return response.data;
  },

  async googleLogin(credential: string) {
    const response = await api.post('/tutor/google-login', { credential });
    if (response.data.access_token) {
      localStorage.setItem('tutor_token', response.data.access_token);
    }
    return response.data;
  },

  logout() {
    localStorage.removeItem('tutor_token');
    localStorage.removeItem('tutor');
  },

  isAuthenticated(): boolean {
    return !!localStorage.getItem('tutor_token');
  },
};

